module.exports = __webpack_public_path__ + "img/submit.3794a0f3.png";